<!-- views/doc/index.vue -->
<template>
  <div>
    <br>
    <div style="background:white;  box-sizing: border-box;">
      <hr>
      <div style="display: flex; padding: 0 4%; justify-content: space-between;">
        <span style="color: #409EFF"><i class="el-icon-s-custom"></i> <a href="/"
                                                                         style="text-decoration:none;color:inherit;">{{
            author
          }}</a></span>
        <span style="color: #409EFF">{{ updateTime }}</span>
        <span style="color: #409EFF" v-if="readCount != null"><i class="el-icon-view"></i> {{ readCount  }}次阅读</span>
      </div>
      <hr>
      <iframe :src="iframe"></iframe>
      <div style=" display: flex; ">
        <el-divider>end</el-divider>
      </div>
    </div>
    <br>
  </div>
</template>
<script>
import {aId, aSecret, author, spaceName} from '@/config/webConfig'
import {getLocalDataWithCheckTimestamp, saveLocalWithTimestamp} from '@/utils/utils'; //,getToken,saveLocalWithTimestamp

export default {
  name: "DocPage",
  data() {
    return {
      aId,
      aSecret,
      author,
      spaceName,
      iframe: null,// 存储从服务器获取的文档数据
      title: null,// 标题
      readCount: null,// 标题
      updateTime: null,// 标题
      token: null,
    };
  },
  methods: {
    updateTitle() {
      if (this.title) {
        document.title = this.title//+" - "+ this.userName;

        // 强制刷新标题（通过短暂地设置为一个不同的值再改回来）
        setTimeout(() => {
          document.title = 'T-Tool.cn'; // 设置一个临时标题
          setTimeout(() => {
            document.title = this.title; // 恢复到实际需要的标题
          }, 100); // 延迟100毫秒
        }, 100); // 延迟100毫秒
      }
    },
    async loadData() {

      const objToken = this.$route.params.objToken; // 获取路由参数中的id
      //这里拿的是objtoken
      //获取文档的信息 这边给到是objToken  实际上这是文章的nodetoken
      this.iframe = "https://" + spaceName + ".feishu.cn/wiki/" + objToken;
      let doc = getLocalDataWithCheckTimestamp("NODE_TOKEN_" + objToken, 30);
      if (doc == null) {
        doc = {
          title :'',
          readCount :null,
          updateTime :null
        }
        await this.getToken();
        //根据node_token 获取他的节点信息
        try {
          const docRes = await this.$http.get(
              //https://open.feishu.cn/open-apis/wiki/v2/spaces/get_node
              `/open-apis/wiki/v2/spaces/get_node`,
              {
                headers: {
                  'Authorization': this.token
                },
                params: { 'token': objToken ,'obj_type':'wiki'},
              }
          )
          if (docRes.data.code === 0) {
             doc.title = docRes.data.data.node.title
            console.log("获取到文章标题：",doc.title)
            saveLocalWithTimestamp("NODE_TOKEN_" + objToken, doc);
          }
        } catch (error) {
          //返回
          console.error("请求失败:", error);
          await this.$router.push({name: 'HomePage'});
        }
      }
      let readCount = getLocalDataWithCheckTimestamp("READ_COUNT_" + objToken, 15)
      if (readCount != null){
        readCount = parseInt(readCount)+1
        saveLocalWithTimestamp("READ_COUNT_" + objToken, readCount);
        this.readCount =  readCount
      }
      this.title = doc.title
      this.updateTime = doc.updateTime
      this.updateTitle();
    },
    //获取token
    async getToken() {
      //'https://open.feishu.cn/open-apis/auth/v3/tenant_access_token/internal',
      if (this.token == null) {
        const tokenRes = await this.$http.post(
            '/open-apis/auth/v3/tenant_access_token/internal',
            {
              app_id: this.aId,
              app_secret: this.aSecret
            },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
        );
        console.log("获取Token:", tokenRes.data)
        // 解析拿到 token
        this.token = 'Bearer ' + tokenRes.data.tenant_access_token
      }
      return this.token
    },
  },
  mounted() {
    this.loadData();
    this.updateTitle();
  },
  watch: {
    '$route': 'loadData', // 当路由变化时重新加载数据并更新标题
    title: 'updateTitle' // 当 title 变化时更新页面标题
  },

};
</script>
<style scoped>
iframe {
  width: 100%;
  height: auto; /* 自动高度 */
  min-height: 300vh; /* 最小高度，视具体情况而定 */
  border: 0;
  scrolling: no;
  overflow: hidden;
  display: block;
}

@media (max-width: 768px) {
  iframe {
    min-height: 500vh; /* 移动设备上的最小高度 */
  }
}
</style>
